import { Transition } from "@headlessui/react";
import { Bell02 } from "@untitled-ui/icons-react";
import classNames from "classnames";
import React, { Fragment } from "react";

import { modulesData } from "@/constants/module-data";
import { type Notification as NotificationType } from "@/types";

import Button from "../../forms/Button";
import FeatureIcon from "../../helpers/FeatureIcon";
import Notification from "../../helpers/Notification";
import NotificationContent from "./NotificationContent";

export default function UserNotificationItem({
  notification,
  onRequestHide,
  className,
}: {
  notification: NotificationType;
  onRequestHide: () => void;
  className?: string;
}) {
  const [show, setShow] = React.useState(true);

  const Icon =
    modulesData.find((m) => m.name === notification.category)?.icon || Bell02;

  return (
    <Transition
      show={show}
      as={Fragment}
      appear
      enter="transform ease-out duration-200"
      enterFrom="-translate-y-8 opacity-0"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0 flex justify-center sm:justify-end"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0 -translate-y-8"
      afterLeave={() => onRequestHide()}
    >
      <div className="flex w-full justify-center sm:justify-end">
        <Notification
          className={classNames(
            "pointer-events-auto w-full max-w-sm overflow-hidden transition sm:w-full",
            className,
          )}
          title={notification.title}
          icon={
            <FeatureIcon variant="outline" color="primary">
              <Icon className="size-5" />
            </FeatureIcon>
          }
          onClose={() => setShow(false)}
        >
          <NotificationContent content={notification.content} />
          <div className="mt-3 flex items-center gap-3">
            <div>
              {notification.action_text && (
                <Button
                  size="sm"
                  color="link-color"
                  onClick={() => {
                    window.open(notification.action_url!, "_blank");
                  }}
                >
                  {notification.action_text}
                </Button>
              )}
            </div>
          </div>
        </Notification>
      </div>
    </Transition>
  );
}
